import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, ViewChild} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { DatePipe } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Observable, map, Subscription } from 'rxjs'; // this created errors ats use below

import {Location} from '@angular/common';
import {UserAvitarModalUploadComponent} from './../user-avitar-modal-upload/user-avitar-modal-upload.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UserFull } from '../../../shared/models/userFull.model';
import { GlobalFunctionsService } from './../../../services/global-functions.service';


/// to access without demo service call
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


@Component({
  selector: 'app-user-create',
  templateUrl: './user-create.component.html',
  styleUrls: ['./user-create.component.css']
})
export class UserCreateComponent implements OnInit {

  

  user_levels: any;
  static brand_id: any;
 // get_latest_user_id: any;
 
   // a declared property

  get_latest_user_id: any;
  returnAPI: Observable<Object>;
  public nav: any;
  public model;
  public today = Date.now();
  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;

  // Passed variables from the Parent Controller - trace-create-step-2
  @Input() ComponentMessage: string;
  @Input() ComponentSendID: string;
  brands: any;
  baseUploadURL: string;
  user_id: string;
  filenameselected: any;
  stripped: any;
  @ViewChild('UserForm') form: any;

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService,
    private _location: Location,
    public gfunc: GlobalFunctionsService
  ) {
    this.nav = document.querySelector('nav.navbar');
  
   }

  ngOnInit() {
    this.model = new UserFull();
    // console.log("Model:" + JSON.stringify(this.model));
    this.model.brand_id = this.ComponentSendID; // links to the Trace
    this.getFormUserLevels();
    this.getBrands();
 
    this.baseUploadURL = this.gfunc.baseUploadURL_UserAssets + '/' + this.user_id; // no trailing slash

    this.ComponentMessage = 'message from parent';
    this.model.brand_id =  +this.route.snapshot.paramMap.get('brand_id');
  //  this.toastr.info('Create A New Login User');
    // this.onsubmit(this.createTraceCandidate(this.model));
  }




   // MODAL view a component
   openModalWithComponent() {
    const initialState = {
      title: 'Upload Image / Photo',
      item_id: 1010,
      user_id: this.user_id,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(UserAvitarModalUploadComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.user_id = this.user_id;
   // this.bsModalRef.content.brand_id = this.brand_id;
    this.bsModalRef.content.item_id = this.user_id;
    this.bsModalRef.content.closeBtnName = 'Close';
    // subscribed to the emitter and get the value.
    this.bsModalRef.content.action.take(1).subscribe((value) => {
  // console.log(value); // here you will get the value of the file
  // Remove the "uploads/" part from the filename.
  this.filenameselected = value;
  this.stripped = this.filenameselected.replace('uploads/', '');
  // this.model.main_image = this.stripped; // works for simple add not update.
  // console.log(this.stripped);
  // console.log(this.model);
  this.form.photo = this.stripped;
  // this.form.reset();
  // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
  this.form.controls['photo'].patchValue(this.form.photo);
  });
   }



   

// kept throwing subscription errors when I was trying to use.
createBrandUser(model) {
  this.model.api_key = '5f1c11b3d80eb7cf6e14029fefd5d8d3';
  this.model.token = 'fake-jwt-token';
  this._demoService.createBrandUser(model).subscribe(
       data => {  this.get_latest_user_id = data; // this is the retuned json upon creation.


        model.last_insert_id = this.get_latest_user_id.last_insert_id;
        model.brand_report_user_id = this.get_latest_user_id.last_insert_id; // Send to the new user in automations "brand_report_user or new user"
        // required for new automation type variables to render as report user.
        model.custom_run = 'user_welcome_email';
         model.created_by = this.gfunc.sessionUserId;

        // new trigge and automation so I can run some loops. --- moved to functinos and buttons
        if(model.send_welcome_email){
        this.gfunc.insertLog_CreateUserSendWelcomeEmail(model)
        this.toastr.success('Welcome Email Sent.')

        }
        
        this.gfunc.insertLog_CreateUser(model);



         this.traceAddNotice();
        this.toastr.success('New TSA login user created.')
        // this.gfunc.globalBrandView(model.brand_id);
        this.gfunc.globalUserView(model.last_insert_id);
      //  this.router.navigateByUrl('/home/' + this.get_latest_user_id, {skipLocationChange: true}).then(() =>
      //  this.router.navigate(['/admin/brands/users/view' + this.model.user_id]));
         //  return true;
       },
       error => {
         this.toastr.error('Adding User Failed :: Please try again!');
         // console.log(Observable.throw(error));
         // return Observable.throw(error);
       }
  );
  }

  traceAddNotice () {
    this.toastr.info('User Added');
  };



  getFormUserLevels() {
    this._demoService.getFormUserLevels().subscribe(
       data2 => { this.user_levels = data2;
        console.log(data2);
     },
       err => console.error(err),
       () => console.log('done loading User Levels')
     );
   }


   getBrands() {
    this._demoService.getBrands().subscribe(
       data2 => { this.brands = data2;
       // console.log(data2);
     },
       err => console.error(err),
       () => console.log('done loading User Brands')
     );
   }

   // to router navigate back
   public goBack() {
    this._location.back();
  }
  
  
  userView(user_id) {
    this.router.navigate(['/admin/brands/users/view/' + user_id + '']);
  }
  
  userEdit(user_id) {
    this.router.navigate(['/admin/brands/users/edit/' + user_id + '']);
  }


}
